import axios from '../Api/api';

export default function surveyEdit(trxId) {
    return new Promise((resolve, reject) => {
        axios.get("/product/getResubmitSurvey", {
            params: {
                trxId: trxId
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
